import styled from 'styled-components'
import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { videos } from 'src/constants/videos'
export default (props) => (
  <StyledContainer>
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={videos.mlbtv.videoUrl}
      staticAnnotation={videos.mlbtv.staticAnnotation}
      title="Get MLB.TV with Fubo"
      subtitle="Watch +2000 live games and much more. See every out-of-marketing team in action"
      heroCtaNote={
        <>
          Blackout and other restrictions apply. Major League Baseball trademarks and copyrights are
          used with permission of Major League Baseball. Visit{' '}
          <a href="MLB.com" target="_blank" style={{ textDecoration: 'underline' }}>
            MLB.com
          </a>{' '}
          for details.
        </>
      }
      networkSubtitle="Watch Premier League, Serie A, MLB & so much more?"
      networkSet="canadaEssentials"
      plansSubtitle="Canada’s home to streaming live sports and top entertainment"
      customNetworks={['mlbtv']}
      league="mlb"
      soccerPlanCardImage="https://assets-imgx.fubo.tv/marketing/lp/images/card/canada/ca_card_mlb-tv.jpg?w=750&ch=width&auto=format,compress"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-jomboy.png?w=450&ch=width&auto=format,compress"
      planCardsConfig={{
        plans: [canadaPlanData.mlbtv_offer],
        overrides: {
          mlbtv_offer: {
            all: {
              promoImg:
                'https://assets-imgx.fubo.tv/marketing/lp/images/card/canada/ca_card_mlb-tv.jpg?w=750&ch=width&auto=format,compress',
            },
          },
        },
      }}
    />
  </StyledContainer>
)

const StyledContainer = styled.div`
  .planCard .planCard__content .planCard__header .planCard__price {
    flex-wrap: wrap;
  }
`
